﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import type { LoginPageCustomizations } from "~base/Pages/Account/Login";

export default {
    useLoginSplashScreen: false,
} as LoginPageCustomizations;
